import React from 'react'

import { LOOKBACK_VALUES } from '_components/lookback-select/index.jsx'

import Horizontal from '../layouts/Horizontal.jsx'
import Card from '../components/Card.jsx'
import WordCloud from '../components/WordCloud.jsx'
import ZeroState from '../components/ZeroState.jsx'
import LoadingState from '../components/LoadingState.jsx'
import useRect from '../hooks/useRect.js'

import useRequest from '../hooks/useRequest.js'
import { getTrendingTopics } from '_services/insights-v2.js'

const format = (data, topics) => {
  if (!data || !topics?.length) return null
  const formatted = topics
    .map((topic) => {
      const item = data[topic.replaceAll(' ', '_').toLowerCase()]
      if (!item) return null
      const totalSize = Object.values(item).reduce((acc, { size }) => acc + size, 0)
      return [topic, totalSize]
    })
    .filter(Boolean)

  return Object.fromEntries(formatted)
}

const TopicsCloud = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const {
    selected_entities,
    title,
    description,
    section_1,
    lookback = LOOKBACK_VALUES.MONTH_6,
  } = props.data

  const topics = selected_entities.map((entity) => {
    if (typeof entity === 'string') return entity
    return entity.orig_name
  })

  const { data, loading } = useRequest(
    getTrendingTopics,
    { audienceId, lookback, terms: topics },
    topics?.length >= 2
  )

  const wordCloudData = format(data, topics)

  const [Rect, rect] = useRect()

  return (
    <Horizontal
      title={title}
      description={description}
      page={props.index + 1}
      content={() => (
        <Card title={section_1.title} description={section_1.subtitle} showBorder={false}>
          <Rect />
          <Choose>
            <When condition={loading}>
              <LoadingState />
            </When>
            <Otherwise>
              <ZeroState
                condition={Object.keys(wordCloudData ?? {}).length >= 2}
                placeholder="Add at least 2 topics."
              >
                <WordCloud
                  data={wordCloudData}
                  limit={25}
                  height={rect.height}
                  width={rect.width}
                  y={0}
                />
              </ZeroState>
            </Otherwise>
          </Choose>
        </Card>
      )}
    />
  )
}

export default TopicsCloud
